<script>
  import config from '../../libs/config.js';

  import api from '../../api'

	import { mapGetters, mapActions } from 'vuex'
	
	export default 
	{
		name: 'createTeam',
		data() 
        {
        	return {
            loading: false,
            workspace: '',
            error: false,
            departments: [],
            companies: ['1']
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser'])
        },
      methods: {
        next(){

          if(!this.workspace){
            return alert('cannot be empty');
          }

          this.loading = true

          let company = { "name": this.workspace }

          // 1- Create new company
          api.post("/api/v1/companies", company, (err, data) => {
            if (err) return console.log(err);

            let payload = {
              department : { _id: this.departments.filter(function (el) {return el.name === 'Management' })[0]._id },
              user: { _id: this.getUser._id }
            }

              // 2- Add user into company
              api.post('/api/v1/companies/'+ data._id +'/users', payload, (err, data) => {
                if(err) return console.log(err);

                  this.loading = false;

                this.$router.push({ name: "team" });
              })

            });
        }
      },
        created(){
          
          // 1- Fetch statuses
          api.get('/api/v1/departments', (err,data) => {
            if(err) return console.log(err)
            this.departments = data

            // 2- Check company whether exist or not
            api.get('/api/v1/companies?user=' + this.getUser._id, (err,data) => {
              if(err) return console.log(err)

              this.companies = data

              if(data.length) return this.$router.push({ name: "accounts" });
            })

          })

        }
	}
</script>

<template>
<span>

  <div v-if="companies.length" data-aos="zoom-in" style="height:100%;" class="ui grid centered middle aligned stackable">
    <div class="six wide computer sixteen wide mobile column">
      <div class="ui basic segment center aligned">
        <div class="ui basic segment padded">
        <img class="ui image centered" style="width: 55px;" src="/img/logo.png" alt="">
        </div>
        <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
       </div>
    </div>
  </div>

  <div v-if="!companies.length" style="height:100%;" class="ui grid centered middle aligned stackable">
    <div class="six wide computer sixteen wide mobile column">
      <div class="ui basic large segment">
        <h2>Team 🎉</h2>
        <p>Hello {{getUser.name}} 👋 </p>
        <p>Let's create your Team.</p>

          <div data-aos="fade-in"  class="ui large form">
          <div class="field">
            <label>Company or Team Name</label>
            <div v-bind:class="{ error: error }" class="ui input">
            <input v-model="workspace" placeholder="Apple / Samsung / Eddie's Workspace" v-on:keyup.enter="next()" type="text">
            </div>
          </div>
           <div class="ui divider"></div>
                     <button @click="next()" v-bind:class="{ loading: loading }" :disabled="loading" class="ui large green button right floated">Create</button>
        </div>
      </div>
    </div>

  </div>
</span>
</template>



// WEBPACK FOOTER //
// src/components/dashboard/createTeam.vue